var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
var InputOuter = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var InputInner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var InputHolder = function (props) {
    return (React.createElement(InputOuter, { justifyContent: "space-between" },
        React.createElement(InputInner, null, props.children)));
};
var templateObject_1, templateObject_2;
